export class StaticDataEnchantment {
    constructor(
        public name: string,
        public values?: number[],
    ) {}
}
